import React from "react";

// Trans requires a self closing component, so we use this one to wrap everything
const TransContent: FC<{ content?: React.ReactNode | null }> = ({ content }) => {
	return <>{content || null}</>;
};
export const TC = TransContent;
